module.exports = __webpack_public_path__ + "static/media/Jon13.aa2e79a7.jpg";